export default "__VITE_PUBLIC_ASSET__7207e1ea__"